import { render } from "./MoreNews.vue?vue&type=template&id=f1a85eda&scoped=true"
import script from "./MoreNews.vue?vue&type=script&lang=js"
export * from "./MoreNews.vue?vue&type=script&lang=js"

import "./MoreNews.vue?vue&type=style&index=0&id=f1a85eda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1a85eda"]])

export default __exports__